module.exports = __webpack_public_path__ + "static/media/COMP-logo.93c4bb1a.png";